import {
  ISSUEMANAGELIST} from 'actions/issueManage';
import {reducerPackage} from "../../utils";
//问题
export const issueManageList = reducerPackage(ISSUEMANAGELIST);

